import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Image from '../Image';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * A container for banner roulette,
 * used with JSON string content with backward compatibility with HTML content
 */

export default function IncludeBanner({
  id,
  gradParams,
  bgImageUrl,
  bgImageMobileUrl,
  webpBgImageUrl,
  webpMobileBgImageUrl,
  bgColor,
  url,
  title,
  textColor,
  target,
  isMobile,
  onClick,
  className,
}) {
  const useWebp = !!(webpBgImageUrl && webpMobileBgImageUrl);
  const src = useWebp ? webpBgImageUrl : bgImageUrl;
  const mobileSrc = useWebp ? webpMobileBgImageUrl : bgImageMobileUrl;

  const isValidGradient = (gradient) => {
    const re = /(?:[^("|')]|^)(linear-gradient)/;

    // search only string begining exactly linear-gradient
    return gradient ? gradient.match(re) : null;
  };
  return (
    <a
      className={cx('contentHolder', className, isMobile && 'mobile')}
      data-banner-id={id}
      data-banner-name={title}
      data-component="Link"
      href={url}
      target={target}
      rel={target && target === '_blank' ? 'noopener noreferrer' : null}
      style={{ background: isValidGradient(gradParams) ? gradParams : bgColor, color: textColor }}
      onClick={onClick}
    >
      <Image
        id={title}
        src={isMobile ? mobileSrc : src}
        useWebp={useWebp}
        fallbackClassName={cx('contentFallback', isMobile && 'mobile')}
      />
    </a>
  );
}

export const IncludeBannerProps = {
  onClick: PropTypes.func,
  isMobile: PropTypes.bool,
  id: PropTypes.string,
  url: PropTypes.string,
  gradParams: PropTypes.string,
  bgImageUrl: PropTypes.string,
  bgImageMobileUrl: PropTypes.string,
  webpBgImageUrl: PropTypes.string,
  webpMobileBgImageUrl: PropTypes.string,
  bgColor: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
};

IncludeBanner.propTypes = IncludeBannerProps;

IncludeBanner.defaultProps = {
  id: '',
  url: '/shop/',
  bgImageUrl: '',
  bgImageMobileUrl: '',
  bgColor: '#FFFFFF',
  gradParams: '',
  webpBgImageUrl: '',
  webpMobileBgImageUrl: '',
  title: '',
  target: '_self',
  textColor: null,
};
